import { Currency, PricingTypeType, SubscriptionPlan } from '@packlink/packlink-sdk';

export const usePlanPrice = (plan: SubscriptionPlan): string => {
    const isRampPricing = plan.pricingType === PricingTypeType.RAMP;
    const price = isRampPricing ? plan.rampIntervals?.[0].rampPricings[0] : plan.fixedPricing;
    const rampLastIntervalPrice =
        isRampPricing && plan.rampIntervals?.[plan.rampIntervals.length - 1].rampPricings[0].unitAmount;
    const priceAmount = isRampPricing ? rampLastIntervalPrice : (price?.unitAmount ?? 0);
    const priceCurrency = price?.currency ?? 'EUR';

    return Currency.format(Number(priceAmount), priceCurrency);
};
